import { Injectable } from '@angular/core';
import { FileData } from '../../models/file-data';
import { UtilityService } from '../utility.service';
import { Observable, Observer, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FileUtilityService {
  constructor(private utilityService: UtilityService) {}

  public getFileDataForFiles(files: File[]): Observable<FileData[]> {
    const fileObservables = files.map(file => this.getFileDataForFile(file));
    return forkJoin(fileObservables);
  }

  public getFileDataForFile(file: File): Observable<FileData> {
    return this.readFileContent(file).pipe(
      map(fileData => {
        return this.parseFileReaderResult(fileData);
      }),
      map(fileData => ({
        name: this.utilityService.formatAttachmentName(file.name),
        data: fileData,
      }))
    );
  }

  private parseFileReaderResult(result: string): string {
    const data = result.split(',');
    if (data.length > 1) {
      // file data after file details
      return data[1];
    } else {
      return result;
    }
  }

  private readFileContent(file: File): Observable<string> {
    return new Observable((observer: Observer<string>) => {
      const reader = new FileReader();

      reader.onload = (): void => {
        observer.next(reader.result as string);
        observer.complete();
      };

      reader.onerror = (error): void => {
        observer.error(error);
      };

      reader.readAsDataURL(file);
    });
  }
}
